module.exports = __webpack_public_path__ + "static/media/Creative Ideation.7c5a1d20.png";